import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { tss } from 'tss-react';

import { useNutrients } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpView/IngredientProductMappingComponent/ColumnSelectionOverlay';
import * as NutrientList from 'types/_general/Store/NutrientList';

interface DataMap {
	[nutrientId: string]: number | null;
}

interface IProps {
	nutrients: DataMap;
}

interface Nutrient {
	name: string;
	quantity: number;
	unit: string;
}

const NutrientsData = (props: IProps) => {
	if (!props.nutrients) return <></>;

	const { classes } = useStyles();
	const nutrientsContext: NutrientList.Type = useNutrients();
	const { t } = useTranslation();

	const nutrients: Nutrient[] = [];

	for (const [key, value] of Object.entries(props.nutrients)) {
		if (value === 0) continue;
		nutrients.push({
			name: nutrientsContext.find((n) => n.id == key)?.name || 'Loading',
			quantity: value || 0,
			unit: nutrientsContext.find((n) => n.id == key)?.unitShortNameSingular || 'Loading',
		});
	}

	return (
		<div className={classes.container}>
			<table className={classes.tableStyle}>
				<thead>
					<tr style={{ backgroundColor: '#f4f4f4' }}>
						<th className={classes.cell}>{t('recipe:NUTRIENT')}</th>
						<th className={classes.cell}>{t('_general:AMOUNT')}</th>
						<th className={classes.cell}>{t('_general:UNIT')}</th>
					</tr>
				</thead>
				<tbody>
					{nutrients.map((nutrient, index) => (
						<tr key={index}>
							<td className={classes.cell}>
								{nutrient.name != 'Loading' ? (
									nutrient.name
								) : (
									<Spinner animation="border" role="status" size="sm"></Spinner>
								)}
							</td>
							<td className={classes.cell}>{nutrient.quantity}</td>
							<td className={classes.cell}>
								{nutrient.unit != 'Loading' ? (
									nutrient.unit
								) : (
									<Spinner animation="border" role="status" size="sm"></Spinner>
								)}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default NutrientsData;

export const useStyles = tss.create({
	container: {
		maxWidth: '600px',
		maxHeight: '600px',
		margin: '0 auto',
		padding: '20px',
		overflowY: 'scroll',
	},
	cell: {
		border: '1px solid #ddd',
		padding: '8px',
	},
	tableStyle: {
		width: '100%',
		borderCollapse: 'collapse',
		marginTop: '10px',
	},
});
